import { render, staticRenderFns } from "./QuestionsComponent.vue?vue&type=template&id=1d56c086&scoped=true&"
import script from "./QuestionsComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsComponent.vue?vue&type=style&index=0&id=1d56c086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56c086",
  null
  
)

export default component.exports